<template>
    <v-container :fluid="true">
      <v-card v-if="isWordListReady && !editPage && !confirmPage" :flat="true">
      <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
        {{ wordList.lbl_shop_list }}
      </v-card-title>
      <v-card-text>
                <v-card :flat="true">
                  <!-- 検索条件入力 { -->
                  <v-expansion-panels v-model="panel" :flat="true" :multiple="true" class="br_1">
            <v-expansion-panel>
              <v-expansion-panel-title class="py-0 font-weight-bold bk_gray_3">
                {{ wordList.lbl_search }}
              </v-expansion-panel-title>
              <v-expansion-panel-text class="bk_gray_3 pt-0" eager>
                <v-divider/>
                <Form v-slot="{ meta, setFieldValue }">
                  <v-card :flat="true" class="bk_gray_3">
                    <v-card-text class="pt-9">
                      <v-row>
                        <!-- チェーンコード -->
                        <v-col
                          v-if="chainViewFlag"
                          cols="12"
                          sm="6"
                          md="4"
                          class="py-0"
                        >
                                                    <Field
                                                      v-slot="{ field, errors }"
                                                      name="chain_name"
                                                      :label="wordList.lbl_chain_name"
                                                      rules="required"
                                                    >
                                                      <v-autocomplete
                                                        :model-value="field.value ?? chainSelectValues"
                                                        density="compact"
                                                        :items="chainListItems"
                                                        item-title="name"
                                                        item-value="chain_code"
                                                        :label="wordList.lbl_chain_name"
                                                        :placeholder="wordList.plc_selectbox"
                                                        :no-data-text="wordList.lbl_no_data_text"
                                                        bg-color="white"
                                                        return-object
                                                        variant="outlined"
                                                        :error-messages="errors"
                                                        @update:model-value="(val) => { field.onChange(val); chainSelectValues = val; handleChangeChain(setFieldValue); }"
                                                        @blur="field.onBlur"
                                                      ></v-autocomplete>
                                                    </Field>
                        </v-col>
                        <!-- 店舗コード -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                                                    <Field
                                                      v-slot="{ field, errors }"
                                                      name="shop_code"
                                                      :label="wordList.lbl_shop_code"
                                                      rules="max:100"
                                                    >
                                                      <v-text-field
                                                        :model-value="field.value ?? searchConditionShopCode"
                                                        :label="wordList.lbl_shop_code"
                                                        bg-color="#fff"
                                                        density="compact"
                                                        variant="outlined"
                                                        clearable
                                                        :error-messages="errors"
                                                        @update:model-value="(val) => { field.onChange(val); searchConditionShopCode = val; }"
                                                        @blur="field.onBlur"
                                                      ></v-text-field>
                                                    </Field>
                        </v-col>
                        <!-- 店舗名 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                                                    <Field
                                                      v-slot="{ field, errors }"
                                                      name="shop_name"
                                                      :label="wordList.lbl_shop_name"
                                                      rules="max:100"
                                                    >
                                                      <v-autocomplete
                                                        :model-value="field.value ?? ShopNameSelectValues"
                                                        :items="shopListItems"
                                                        item-title="name"
                                                        item-value="shop_code"
                                                        :label="wordList.lbl_shop_name"
                                                        :placeholder="wordList.lbl_shop_name"
                                                        :no-data-text="wordList.lbl_no_data_text"
                                                        :error-messages="errors"
                                                        density="compact"
                                                        multiple
                                                        variant="outlined"
                                                        return-object
                                                        bg-color="#fff"
                                                        @update:model-value="(val) => { field.onChange(val); ShopNameSelectValues = val; }"
                                                        @blur="field.onBlur"
                                                      ></v-autocomplete>
                                                    </Field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <!-- 郵便番号 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                                                    <Field
                                                      v-slot="{ field, errors }"
                                                      name="zipcode"
                                                      :label="wordList.lbl_zipcode"
                                                      rules="max:100"
                                                    >
                                                      <v-text-field
                                                        :model-value="field.value ?? searchConditionZipCode"
                                                        :label="wordList.lbl_zipcode"
                                                        bg-color="#fff"
                                                        density="compact"
                                                        variant="outlined"
                                                        clearable
                                                        :error-messages="errors"
                                                        @update:model-value="(val) => { field.onChange(val); searchConditionZipCode = val; }"
                                                        @blur="field.onBlur"
                                                      ></v-text-field>
                                                    </Field>
                        </v-col>
                        <!-- 住所 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                                                    <Field
                                                      v-slot="{ field, errors }"
                                                      name="address"
                                                      :label="wordList.lbl_address"
                                                      rules="max:100"
                                                    >
                                                      <v-text-field
                                                        :model-value="field.value ?? searchConditionAddress"
                                                        :label="wordList.lbl_address"
                                                        bg-color="#fff"
                                                        density="compact"
                                                        variant="outlined"
                                                        clearable
                                                        :error-messages="errors"
                                                        @update:model-value="(val) => { field.onChange(val); searchConditionAddress = val; }"
                                                        @blur="field.onBlur"
                                                      ></v-text-field>
                                                    </Field>
                        </v-col>
                        <!-- 電話番号 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                                                    <Field
                                                      v-slot="{ field, errors }"
                                                      name="tel"
                                                      :label="wordList.lbl_tel"
                                                      rules="max:100"
                                                    >
                                                      <v-text-field
                                                        :model-value="field.value ?? searchConditionPhone"
                                                        :label="wordList.lbl_tel"
                                                        bg-color="#fff"
                                                        density="compact"
                                                        variant="outlined"
                                                        clearable
                                                        :error-messages="errors"
                                                        @update:model-value="(val) => { field.onChange(val); searchConditionPhone = val; }"
                                                        @blur="field.onBlur"
                                                      ></v-text-field>
                                                    </Field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        variant="flat"
                        color="primary"
                        class="px-16 mt-6"
                        :disabled="!meta.valid || searchConditionChainCode === ''"
                        @click="onClickSearch"
                      >
                        <v-icon>mdi-magnify</v-icon>
                        {{ wordList.lbl_search }}
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </Form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- 検索条件入力 } -->
          <!-- 一覧表示  { -->
          <v-card :flat="true" width="100%">
            <v-data-table-server
              v-model="selectListCheckbox"
              item-value="shop_code"
              :page="listOptions.page"
              :items-per-page="listOptions.itemsPerPage"
              :items="listDataArray"
              :loading="listLoading"
              :no-data-text="wordList.lbl_no_data_text"
              :headers="tableHeaders"
              :row-props="() => ({ class: 'bk_gray_1' })"
              :items-length="listDataTotalCount"
              hide-default-footer
              show-select
              return-object
              @update:options="(opts) => Object.assign(listOptions, opts)"
            >
              <template #top>
                <div
                  class="d-flex justify-space-between align-center mt-9 mb-5"
                >
                  <div class="d-flex align-center">
                    <span>
                      {{ wordList.lbl_all }} {{ listDataTotalCount }}
                      {{ wordList.lbl_num }}
                    </span>
                    <span class="pl-1"> {{ displayPagingRange }} </span>
                    <v-pagination
                      v-model="listOptions.page"
                      :length="pageCount"
                      :total-visible="7"
                      variant="elevated"
                      density="comfortable"
                    >
                    </v-pagination>
                  </div>
                  <v-menu open-on-hover location="bottom">
                    <template #activator="{ props }">
                      <v-btn variant="text" color="black" v-bind="props">
                        {{ wordList.lbl_action }}
                        <v-icon>mdi-cog</v-icon>
                      </v-btn>
                    </template>
                    <!-- 一括削除ボタン -->
                    <v-list width="250" class="pl-5">
                      <v-list-item-title
                        style="cursor: pointer"
                        @click="onClickCheckDelete"
                      >
                        <v-icon class="mr-2">mdi-delete</v-icon>
                        {{ wordList.lbl_delete_all }}
                      </v-list-item-title>
                    </v-list>
                  </v-menu>
                </div>
              </template>
              <template #[`item.actions`]="{ item }">
                <div>
                  <v-btn
                    icon
                    variant="outlined"
                    color="primary"
                    class="my-2 ml-2"
                    size="x-small"
                    rounded="circle"
                    @click="onClickEdit(item.shop_code)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>

                  <v-btn
                    icon
                    variant="outlined"
                    color="red"
                    class="my-2 ml-2 mr-0"
                    size="x-small"
                    rounded="circle"
                    @click="onClickDelete(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table-server>
          </v-card>
        </v-card>
      </v-card-text>
    </v-card>
    <!-- 店舗個別削除確認 { -->
    <v-card v-if="isWordListReady && confirmPage" :flat="true">
      <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
        {{ wordList.lbl_delete_confirm }}
      </v-card-title>
      <v-card-text class="confirm-display-text">
        <!-- チェーンコード -->
        <v-row v-if="chainViewFlag" dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_chain_name }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteShop.chain_code }}
          </v-col>
        </v-row>
        <!-- 店舗コード -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_shop_code }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteShop.shop_code }}
          </v-col>
        </v-row>
        <!-- 店舗名 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_shop_name }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteShop.name }}
          </v-col>
        </v-row>
        <!-- 店舗名かな -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_shop_name_kana }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteShop.name_kana }}
          </v-col>
        </v-row>
        <!-- 休日設定 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_holiday_setting }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ holidaySetting }}
          </v-col>
        </v-row>
        <!-- 郵便番号 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_zipcode }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteShop.zip_code }}
          </v-col>
        </v-row>
        <!-- 住所 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_address }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteShop.address1 }}{{ deleteShop.address2 }}{{ deleteShop.address3 }}
          </v-col>
        </v-row>
        <!-- 電話番号 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_tel }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteShop.phone }}
          </v-col>
        </v-row>
        <!-- FAX -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_fax }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteShop.fax }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center flex-wrap flex-wrap py-10">
        <v-btn
          variant="flat"
          color="return"
          class="btn_width_1 my-2 mx-2"
          @click="onClickConfirmDeleteCancel"
        >
          <v-icon>mdi-arrow-left</v-icon>
          {{ wordList.btn_return }}
        </v-btn>
        <v-btn
          v-if="processFlag == 2"
          variant="flat"
          color="primary"
          class="btn_width_1 my-2 mx-2"
          @click="onClickConfirmDeleteOk"
        >
          <v-icon>mdi-playlist-edit</v-icon>
          {{ wordList.btn_delete_complete }}
        </v-btn>
      </v-card-actions>
      <v-overlay
        :model-value="overlay"
        class="d-flex align-center justify-center"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
    <!-- } 配達依頼更新確認 -->
    <!-- 削除確認ダイアログ {-->
    <v-dialog
      v-model="confirmDeleteDialog"
      content-class="dialog_width_1"
      :lock-scroll="false"
      scrollable
    >
      <v-data-iterator
        :items="selectListCheckbox"
        item-key="shop_code"
        hide-default-footer
        :items-per-page="-1"
      >
        <template #default="{ items }">
          <v-card class="rounded-b-0">
            <v-card-title class="bg-red mb-5" style="color: white">
              {{ wordList.lbl_delete_all_confirm }}
            </v-card-title>

            <v-card-text class="font-weight-black">
              {{ selectListCheckbox.length }}
              {{ wordList.lbl_delete_all_msg }}
            </v-card-text>

            <v-card-text style="max-height: 60vh; overflow-y: auto;">
              <v-card
                v-for="{ raw } in items"
                :key="raw.shop_code"
                flat
                border
                class="mb-5"
              >
                <v-list density="compact">
                  <!-- チェーンコード -->
                  <v-list-item v-if="chainViewFlag">
                    <v-row dense>
                      <v-col cols="5" sm="3" class="font-weight-black">
                        <v-row dense class="py-2 justify-end">
                          {{ wordList.lbl_chain_name }}:
                        </v-row>
                      </v-col>
                      <v-col cols="7" class="d-flex align-center">
                        {{ raw.chain_code }}
                      </v-col>
                    </v-row>
                  </v-list-item>

                  <!-- 店舗コード -->
                  <v-list-item>
                    <v-row dense>
                      <v-col cols="5" sm="3" class="font-weight-black">
                        <v-row dense class="py-2 justify-end">
                          {{ wordList.lbl_shop_code }}:
                        </v-row>
                      </v-col>
                      <v-col cols="7" class="d-flex align-center">
                        {{ raw.shop_code }}
                      </v-col>
                    </v-row>
                  </v-list-item>

                  <!-- 店名 -->
                  <v-list-item>
                    <v-row dense>
                      <v-col cols="5" sm="3" class="font-weight-black">
                        <v-row dense class="py-2 justify-end">
                          {{ wordList.lbl_shop_name }}:
                        </v-row>
                      </v-col>
                      <v-col cols="7" class="d-flex align-center">
                        {{ raw.shop_name }}
                      </v-col>
                    </v-row>
                  </v-list-item>

                  <!-- 郵便番号 -->
                  <v-list-item>
                    <v-row dense>
                      <v-col cols="5" sm="3" class="font-weight-black">
                        <v-row dense class="py-2 justify-end">
                          {{ wordList.lbl_zipcode }}:
                        </v-row>
                      </v-col>
                      <v-col cols="7" class="d-flex align-center">
                        {{ raw.zip_code }}
                      </v-col>
                    </v-row>
                  </v-list-item>

                  <!-- 住所 -->
                  <v-list-item>
                    <v-row dense>
                      <v-col cols="5" sm="3" class="font-weight-black">
                        <v-row dense class="py-2 justify-end">
                          {{ wordList.lbl_address }}:
                        </v-row>
                      </v-col>
                      <v-col cols="7" class="d-flex align-center">
                        {{ raw.address }}
                      </v-col>
                    </v-row>
                  </v-list-item>

                  <!-- 電話番号 -->
                  <v-list-item>
                    <v-row dense>
                      <v-col cols="5" sm="3" class="font-weight-black">
                        <v-row dense class="py-2 justify-end">
                          {{ wordList.lbl_tel }}:
                        </v-row>
                      </v-col>
                      <v-col cols="7" class="d-flex align-center">
                        {{ raw.tel }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-card-text>
          </v-card>
        </template>
        <template v-slot:footer>
          <v-card flat class="py-4 rounded-t-0">
            <v-row justify="center">
              <!-- 戻るボタン -->
              <v-btn
                @click="confirmDeleteDialog = false"
                depressed
                color="return"
                class="px-16 mx-2 my-2"
                width="168px"
              >
                <v-icon>mdi-arrow-left</v-icon>
                {{ wordList.btn_return }}
              </v-btn>
              <v-btn
                outlined
                class="bg-red-darken-1 mx-2 my-2"
                color="white"
                width="168px"
                @click="onClickCheckDeleteComplete"
              >
                {{ wordList.lbl_delete_all }}
              </v-btn>
            </v-row>
          </v-card>
        </template>
      </v-data-iterator>
      <v-overlay
        :model-value="overlay"
        class="d-flex align-center justify-center"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>
    <!-- } 削除確認ダイアログ -->
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
    />
  </v-container>
</template>

<script setup lang="ts">
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import { required, max } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import AlertDialog from "@/components/AlertDialog.vue";
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import type { SetFieldValue } from "./types";

import { useShopListUiState } from "./composables/useShopListUiState";
import { useShopListSearchForm } from "./composables/useShopListSearchForm";
import { useShopListTable } from "./composables/useShopListTable";
import { useShopListActions } from "./composables/useShopListActions";
import { useShopListInit } from "./composables/useShopListInit";

/* vee-validate ルール設定 */
defineRule("required", required);
defineRule("max", max);
configure({
  generateMessage: localize({
    ja,
  }),
});
setLocale("ja");

/* ルーティング */
const route = useRoute();

/* ===================================================================================
 * composables 初期化
 * =================================================================================== */

// UI状態
const {
  errdialog,
  errMessage,
  editPage,
  confirmPage,
  processFlag,
  confirmDeleteDialog,
  panel,
  overlay,
  openConfirmDeletePage,
} = useShopListUiState();

// 検索フォーム（テーブルより先に生成 — テーブルが検索条件refを参照するため）
const {
  chainListItems,
  chainSelectValues,
  shopListInput,
  shopListItems,
  ShopNameSelectValues,
  chainViewFlag,
  searchConditionChainCode,
  searchConditionShopCode,
  searchConditionPhone,
  searchConditionZipCode,
  searchConditionAddress,
  onChangeChain,
} = useShopListSearchForm({
  errdialog,
  errMessage,
});

// 一覧・ページング
const {
  tableHeaders,
  listLoading,
  listOptions,
  displayPagingRange,
  listDataArray,
  listDataTotalCount,
  pageCount,
  selectListCheckbox,
  initializeTableHeaders,
  onClickSearch,
  searchQuery,
} = useShopListTable({
  searchConditionChainCode,
  searchConditionShopCode,
  searchConditionPhone,
  searchConditionZipCode,
  searchConditionAddress,
  ShopNameSelectValues,
  chainViewFlag,
  errdialog,
  errMessage,
});

/**
 * チェーン変更時ハンドラ（テーブル状態リセットを含むラッパー）
 */
const handleChangeChain = (setFieldValue: SetFieldValue): void => {
  onChangeChain(setFieldValue, () => {
    listDataArray.value = [];
    listOptions.page = 1;
    listDataTotalCount.value = 0;
  });
};

// アクション（編集・削除）
const {
  displayConfirmDeleteDialog,
  deleteShop,
  holidaySetting,
  onClickEdit,
  onClickCheckDelete,
  onClickCheckDeleteComplete,
  onClickDelete,
  onClickConfirmDeleteCancel,
  onClickConfirmDeleteOk,
} = useShopListActions({
  searchConditionChainCode,
  searchConditionShopCode,
  searchConditionPhone,
  searchConditionZipCode,
  searchConditionAddress,
  chainSelectValues,
  ShopNameSelectValues,
  chainViewFlag,
  errdialog,
  errMessage,
  editPage,
  confirmPage,
  overlay,
  confirmDeleteDialog,
  selectListCheckbox,
  searchQuery,
  openConfirmDeletePage,
  getCurrentPage: () => listOptions.page,
});

// 初期化
const {
  wordList,
  isWordListReady,
  runInitialLoad,
} = useShopListInit({
  chainViewFlag,
  chainListItems,
  chainSelectValues,
  shopListInput,
  shopListItems,
  ShopNameSelectValues,
  searchConditionChainCode,
  searchConditionShopCode,
  searchConditionPhone,
  searchConditionZipCode,
  searchConditionAddress,
  errdialog,
  errMessage,
  initializeTableHeaders,
  onClickSearch,
  listOptions,
});

onMounted(async (): Promise<void> => {
  await runInitialLoad(route);
});
</script>

<style scoped>
/* Vuetify v3のv-expansion-panel-textの内部ラッパースタイル指定 */
:deep(.v-expansion-panel-text__wrapper) {
  padding-top: 0px;
}
</style>
